import find from 'lodash/find';

export const titles = (page, substitute) => {
  const suffix = `Zeus Comics`;
  const keywords = `comic books, graphic novels, toys, statues, discount prices, national shipping`;
  const contents =[
    {
      page: `home`,
      title: `Zeus Comics and Collectibles`,
    },
    {
      page: `about`,
      title: `About Us - ${suffix}`,
    },
    {
      page: `checklist`,
      title: `Pull List: Buy comic books online and get 10% off. We ship direct.`,
    },
    {
      page: `category`,
      title: `${substitute} – Buy online ${substitute} - ${suffix}`,
    },
    {
      page: `artist`,
      title: `${substitute}, comic book artist – Buy online ${keywords}`,
    },
    {
      page: `author`,
      title: `${substitute}, comic book author – Buy online ${keywords}`,
    },
    {
      page: `loves`,
      title: `${substitute} – Find the latest ${substitute} - ${suffix}`,
    },
    {
      page: `search`,
      title: `${substitute} - results ${keywords}${suffix}`,
    },
    {
      page: `products`,
      title: `${substitute} - ${suffix}`,
    },
    {
      page: `publisher`,
      title: `${substitute}, ${keywords} - ${suffix}`,
    },
    {
      page: `subscriptions`,
      title: `Comic book subscription service, save 10% each week, we ship direct. ${suffix}`,
    },
    {
      page: `cart`,
      title: `Your cart - ${suffix}`,
    },
    {
      page: `cartCheckout`,
      title: `Checkout - ${suffix}`,
    },
    {
      page: `cartThanks`,
      title: `Thank you for your order! - ${suffix}`,
    },
    {
      page: `checklistShare`,
      title: `Check out my pull list! Here are some from this week's subscription - ${suffix}`,
    },
    {
      page: `news`,
      title: `${substitute} - ${suffix}`,
    },
    {
      page: `foc`,
      title: `Preorders - get comic books and variants at a great discount our Final Order Cutoff form. ${keywords} - ${suffix}`,
    },
    {
      page: `new`,
      title: `New Comic book releases this week - ${suffix}`,
    },
    {
      page: `focThanks`,
      title: `Thank you for your Preorder! - ${suffix}`,
    },
  ];

  return find(contents, (content) => content.page === page);
}
